
/*
The purpose of the following is to make it so the main
image on the product page changes depending on which
of the thumbnail images is clicked.

This works because in product-template.liquid
all of the images for the product are all stacked
on top of eachother with only the first one active
the rest are set to display: none

This is done using the classes: active-product-img(visable) and inactive-product-img(hidden)


step 1.
by default all of the thumbnails have links to larger versions of the image, so people without
javascript enabled can click on the thumbnails to see larger versions of the image.

So first we remove those to prevent any interference with the javascript click functionality

step 2.
in product-template.liquid every thumbnail has the "activateProductImage()" function attached
so when they are clicked, this function is run

this function first changes all of the main stacked images to inactive, then sets the image
matching the clicked thumbnail to active 
It does this using the image.id provided by shopify, that is then passed through "activateProductImage()"


*/

$(document).ready(function(){
  //remove any links that are currently on thumbnails to prevent
  //interference with the img swapping functionality
  removeLinksFromThumbnails();
});

function removeLinksFromThumbnails(){
  var $productThumbnails = $(".product-page-thumbnail");
  $productThumbnails.each(function() {
    $(this).removeAttr("href"); 
  });
}



//this function is attached to all the thumbnails
//
function activateProductImage(imageId){
  console.log(imageId);
  //remove the currently active image
  $currentActiveProduct = $(".active-product-img");
  //the each loop is used just incase somehow multiple images ended up active
  $currentActiveProduct.each(function() {
    $(this).removeClass("active-product-img");
    $(this).addClass("inactive-product-img");
  });

  var id = ("#" + imageId);

  $(id).removeClass("inactive-product-img");
  $(id).addClass("active-product-img");

}

